import httpClient from './httpClient';
import { getTenantConfig } from '../../config/tenantConfig';

const getBaseUrl = () => {
  const config = getTenantConfig();
  return config.api.witnessStatement;
};

export const witnessStatementService = {
  async listStatements(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) {
      params.append('status', filters.status);
    }

    const url = `${getBaseUrl()}/statements${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await httpClient.get(url);
    return response; // httpClient already unwraps response.data
  },

  async getStatement(statementId) {
    const response = await httpClient.get(`${getBaseUrl()}/statements/${statementId}`);
    return response; // httpClient already unwraps response.data
  },

  async createStatement(templateId, userEventId, initialData = {}) {
    const response = await httpClient.post(`${getBaseUrl()}/statements`, {
      template_id: templateId,
      user_event_id: userEventId,
      ...initialData
    });
    return response; // httpClient already unwraps response.data
  },

  async updateStatement(statementId, updates) {
    const response = await httpClient.put(`${getBaseUrl()}/statements/${statementId}`, updates);
    return response; // httpClient already unwraps response.data
  },

  async submitStatement(statementId) {
    const response = await httpClient.post(`${getBaseUrl()}/statements/${statementId}/submit`);
    return response; // httpClient already unwraps response.data
  },

  async affirmContext(statementId) {
    const response = await httpClient.post(`${getBaseUrl()}/statements/${statementId}/affirm-context`);
    return response; // httpClient already unwraps response.data
  },

  async downloadStatement(statementId, format) {
    const response = await httpClient.get(`${getBaseUrl()}/statements/${statementId}/download/${format}`);
    return response; // httpClient already unwraps response.data
  }
};
